// Lib
import React from 'react';

// Components
import Button from '../../../Button';
import InfoCard from './InfoCard';
import EditRecurrenceButton from '../../Buttons/EditRecurrenceButton';
import Spinner from '../../../Spinner';

// Hooks
import useUser from '../../../../hooks/useUser';
import useRecurringOrder from '../../../../pages/OrderHistory/hooks/useRecurringOrder';

// Utils
import { getFormattedNextRunDate } from '../../../../utils/date';

// Styles
import { useStyles } from './RecurringOrderSectionStyles';

const RecurringOrderSection = ({ orderDetails }) => {
  const { isKiteUser } = useUser();
  const { classes } = useStyles({ isKiteUser });
  const { onCancel, onSkip, onEditRecurrence, loadingSkip } = useRecurringOrder(
    orderDetails,
    true,
  );

  return (
    <>
      <div className={classes.buttons}>
        <Button
          loadingIndicator={<Spinner height="initial" size={14} />}
          loading={loadingSkip}
          onClick={onSkip}>
          Skip
        </Button>
        <Button onClick={onCancel} variant="text">
          Cancel
        </Button>
      </div>
      <div className={classes.cards}>
        {orderDetails?.next_run && (
          <InfoCard dataTestId="next-shipping" title="Next Shipping">
            {getFormattedNextRunDate(orderDetails?.next_run)}
          </InfoCard>
        )}
        <InfoCard dataTestId="shipping-method" title="Shipping Method">
          {orderDetails.shipment_method.name}
        </InfoCard>
        <InfoCard dataTestId="recurrence" title="Recurrence">
          <EditRecurrenceButton onClick={onEditRecurrence} />
        </InfoCard>
      </div>
    </>
  );
};

export default RecurringOrderSection;
